import axios from 'axios'
import Config from '../Helpers/Config';

import {requiresRelogin}  from './authActions'


export const fetchProduct = (id) => {
    return function (dispatch) {
        dispatch({
            type: 'FETCHING_UPDATE_SELL_PRODUCT'
        });
        // return axios.get('/data/product-update.json?id='+id)
        return axios.get(Config.api() + 'products/find-sell/'+id,{
            withCredentials:Config.withCredentials()
        })
            .then((response) => {
                if(response.status === 200){
                    dispatch({
                        type: 'FETCH_UPDATE_SELL_PRODUCT',
                        results: response.data
                    });
                }
            }).catch((error) => {
                if(error.response && error.response.status && error.response.status === 401){
                    dispatch(requiresRelogin(true,true))
                }else {
                    dispatch({
                        type: 'FETCHING_UPDATE_SELL_PRODUCT_FAILED'
                    });
                }

            });
    };
};
